/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskEmailRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskEmailRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskEmail, {
	LazyProjectSettingsServiceDeskEmail,
} from './ui/service-desk-email/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskEmailRouteEntry: Route = createEntry(
	projectSettingsServicedeskEmailRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'service-management.settings.email-channels',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskEmail,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskEmail],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
